// extracted by mini-css-extract-plugin
export default {"full-width":"button_full-width__l6qLg"};